import Vue from "vue";
import Router from "vue-router";
import Home from "../views/home";
import Layout from "@/layout";
import SimpleLayout from "@/layout/simple-layout";
import MenuLayout from "@/layout/menu-layout";
import MenuChildLayout from "@/layout/menu-child-layout";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
        meta: { title: "首页" },
      },
      {
        path: "/exhibition-hall",
        meta: { title: "展示大厅" },
        redirect: "/exhibition-hall/exhibition-hall",
        component: SimpleLayout,
        children: [
          {
            path: "exhibition-hall",
            name: "ExhibitionHall",
            component: () => import("@/views/exhibition-hall/exhibition-hall"),
            meta: { title: "展示大厅" },
          },
          {
            path: "solution",
            name: "Solution",
            component: () => import("@/views/exhibition-hall/solution"),
            meta: { title: "解决方案" },
          },
          {
            path: "policy-relevant",
            name: "PolicyRelevant",
            component: () => import("@/views/exhibition-hall/policy-relevant"),
            meta: { title: "政策相关" },
          },
          {
            path: "news-information",
            name: "NewsInformation",
            component: () => import("@/views/exhibition-hall/news-information"),
            meta: { title: "新闻资讯" },
          },
        ],
      },
      {
        path: "identity-resolution",
        name: "IdentityResolution",
        component: () => import("@/views/identity-resolution"),
        meta: { title: "标识解析二级节点" },
      },
      {
        path: "/supply_demand_docking",
        meta: { title: "供需对接" },
        redirect: "/supply_demand_docking/supply-demand-docking",
        component: SimpleLayout,
        children: [
          {
            path: "supply-demand-docking",
            name: "SupplyDemandDocking",
            component: () => import("@/views/supply_demand_docking/supply-demand-docking"),
            meta: { title: "供需对接" },
          },
          {
            path: "supply-demand",
            name: "SupplyDemand",
            component: () => import("@/views/supply_demand_docking/supply-demand"),
            meta: { title: "供需大厅" },
          },
          {
            path: "think-tanks",
            name: "ThinkTanks",
            component: () => import("@/views/supply_demand_docking/think-tanks"),
            meta: { title: "专业智库" },
          },
          {
            path: "financial-service",
            name: "FinancialService",
            component: () => import("@/views/supply_demand_docking/financial-service"),
            meta: { title: "金融服务" },
          },
          {
            path: "case-declaration",
            name: "CaseDeclaration",
            component: () => import("@/views/supply_demand_docking/case-declaration"),
            meta: { title: "数字化案例申报" },
          },
        ],
      },
      {
        path: "/training-practice",
        meta: { title: "培训实训" },
        redirect: "/training-practice/training-practice1",
        component: SimpleLayout,
        children: [
          {
            path: "training-practice1",
            name: "TrainingPractice1",
            component: () => import("@/views/training-practice/training-practice1"),
            meta: { title: "培训实训2" },
          },
          {
            path: "training-practice",
            name: "TrainingPractice",
            component: () => import("@/views/training-practice/training-practice"),
            meta: { title: "培训实训" },
          },
          {
            path: "skills-competition",
            name: "SkillsCompetition",
            component: () => import("@/views/training-practice/skills-competition"),
            meta: { title: "技能大赛" },
          },
          {
            path: "lecture-hall",
            name: "LectureHall",
            component: () => import("@/views/training-practice/lecture-hall"),
            meta: { title: "数字化大讲堂" },
          },
        ],
      },
      {
        path: "app-store",
        meta: { title: "应用商店" },
        redirect: "/app-store/software-supermarket",
        component: SimpleLayout,
        children: [
          {
            path: "software-supermarket",
            name: "SoftwareSupermarket",
            component: () => import("@/views/app-store/software-supermarket"),
            meta: { title: "应用商店" },
          },
          {
            path: "saas-app",
            name: "SaasApp",
            component: () => import("@/views/app-store/saas-app"),
            meta: { title: "软件超市" },
          },
          {
            path: "certification-testing",
            name: "CertificationTesting",
            component: () => import("@/views/app-store/certification-testing"),
            meta: { title: "认证检测服务" },
          },
          {
            path: "cloud-resource",
            name: "CloudResource",
            component: () => import("@/views/app-store/cloud-resource"),
            meta: { title: "云资源服务" },
          },
          {
            path: "joining-applications",
            name: "JoiningApplications",
            component: () => import("@/views/app-store/joining-applications"),
            meta: { title: "开发者中心" },
          },
        ],
      },
      {
        path: "/about-us",
        name: "AboutUs",
        component: () => import("@/views/about-us"),
        meta: { title: "关于我们" },
      },
      {
        path: "/enterprise-cluster",
        name: "EnterpriseCluster",
        component: () => import("@/views/enterprise-cluster"),
        meta: { title: "企业群" },
      },
      {
        path: "/editor",
        redirect: "/article-editor",
      },
      {
        path: "/article-editor",
        name: "ArticleEdit",
        component: () => import("@/views/article-editor"),
        meta: { title: "文档编辑器" },
      },
      {
        path: "dgzz",
        name: "Dgzz",
        component: () => import("@/views/dgzz"),
        meta: { title: "对公转账" },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/staging",
    name: "Staging",
    component: MenuLayout,
    redirect: "/staging/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/staging/dashboard/index.vue"),
        meta: { title: "工作台", icon: "home" },
      },
      {
        path: "dashboardInfo",
        name: "DashboardInfo",
        component: () => import("@/views/staging/dashboard/info.vue"),
        meta: { title: "认证", hidden: true },
      },
      {
        path: "supplyDemandRelease",
        name: "SupplyDemandRelease",
        component: () => import("@/views/staging/supplyDemandRelease/index.vue"),
        meta: {
          title: "供需发布",
          hidden: true,
          icon: "supplyDemandRelease",
          roles: ["Personal", "Expert", "Enterprise"],
        },
      },
      {
        path: "supplyDemandReleaseEditor",
        component: () => import("@/views/staging/supplyDemandRelease/editor.vue"),
        meta: { title: "供需发布编辑器", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "supplyDemandReleaseDetails",
        component: () => import("@/views/staging/supplyDemandRelease/details.vue"),
        meta: { title: "供需发布详情", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "supplyDemandDocking",
        name: "SupplyDemandDockingManage",
        component: () => import("@/views/staging/supplyDemandDocking/index.vue"),
        meta: {
          title: "供需对接",
          hidden: true,
          icon: "supplyDemandDocking",
          roles: ["Personal", "Expert", "Enterprise"],
        },
      },
      {
        path: "supplyDemandDockingDetails",
        component: () => import("@/views/staging/supplyDemandDocking/details.vue"),
        meta: { title: "供需发布详情", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "solutionScheme",
        name: "SolutionScheme",
        component: () => import("@/views/staging/solutionScheme/index.vue"),
        meta: { title: "解决方案", icon: "solutionScheme", roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "solutionSchemeEditor",
        component: () => import("@/views/staging/solutionScheme/editor.vue"),
        meta: { title: "解决方案编辑器", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "solutionSchemeDetails",
        component: () => import("@/views/staging/solutionScheme/details.vue"),
        meta: { title: "解决方案详情", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "scientificAchievement",
        name: "ScientificAchievement",
        component: () => import("@/views/staging/scientificAchievement/index.vue"),
        meta: { title: "科技成果", hidden: true, icon: "scientificAchievement", roles: ["Expert", "Enterprise"] },
      },
      {
        path: "scientificAchievementEditor",
        component: () => import("@/views/staging/scientificAchievement/editor.vue"),
        meta: { title: "科技成果编辑器", hidden: true, roles: ["Expert", "Enterprise"] },
      },
      {
        path: "scientificAchievementDetails",
        component: () => import("@/views/staging/scientificAchievement/details.vue"),
        meta: { title: "科技成果详情", hidden: true, roles: ["Expert", "Enterprise"] },
      },
      {
        path: "achievementTransformation",
        name: "AchievementTransformation",
        component: () => import("@/views/staging/achievementTransformation/index.vue"),
        meta: { title: "成果转化", hidden: true, icon: "achievementTransformation", roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "achievementTransformationDetails",
        component: () => import("@/views/staging/achievementTransformation/details.vue"),
        meta: { title: "成果转化详情", hidden: true, roles: ["Personal", "Expert", "Enterprise"] },
      },
      {
        path: "projectApplication",
        name: "ProjectApplication",
        component: () => import("@/views/staging/projectApplication/index.vue"),
        meta: { title: "项目申报", hidden: true, icon: "report_reminder", roles: ["Enterprise"] },
      },
      {
        path: "projectApplicationDetails",
        component: () => import("@/views/staging/projectApplication/details.vue"),
        meta: { title: "项目申报详情", hidden: true, roles: ["Enterprise"] },
      },
      {
        path: "myMessage",
        name: "MyMessage",
        component: () => import("@/views/staging/myMessage/index.vue"),
        meta: { title: "我的消息", icon: "message" },
      },
      {
        path: "myApp",
        name: "MyApp",
        component: () => import("@/views/staging/myApp/index.vue"),
        meta: {
          title: "我的应用",
          icon: "app",
          // roles: ["Enterprise"]
        },
      },
      {
        path: "myOrder",
        name: "MyOrder",
        component: () => import("@/views/staging/myOrder/index.vue"),
        meta: {
          title: "我的订单",
          icon: "order",
          // roles: ["Enterprise"]
        },
      },
      {
        path: "myAppRecordList",
        name: "MyAppRecordList",
        component: () => import("@/views/staging/myApp/recordList/index.vue"),
        meta: {
          title: "购买记录",
          hidden: true,
          // roles: ["Enterprise"]
        },
      },
      {
        path: "joiningApplications",
        name: "JoiningApplicationsAdmin",
        component: () => import("@/views/staging/joiningApplications/index.vue"),
        meta: {
          title: "开发者中心",
          icon: "joining-app",
          // roles: ["Enterprise"]
        },
      },
      {
        path: "customerProd",
        name: "CustomerProd",
        component: () => import("@/views/staging/customerProd/index.vue"),
        meta: {
          title: "客户订单",
          icon: "customer-prod",
          // roles: ["Enterprise"]
        },
      },
      {
        path: "deployManage",
        name: "DeployManage",
        component: () => import("@/views/staging/joiningApplications/deployManage/index.vue"),
        meta: {
          title: "部署管理",
          hidden: true,
          // roles: ["Enterprise"]
        },
      },
      {
        path: "joiningApplicationsEditor",
        component: () => import("@/views/staging/joiningApplications/editor.vue"),
        meta: {
          title: "编辑应用",
          hidden: true,
          // roles: ["Personal", "Expert", "Enterprise"]
        },
      },
      {
        path: "joiningApplicationsDetails",
        component: () => import("@/views/staging/joiningApplications/details.vue"),
        meta: {
          title: "应用详情",
          hidden: true,
          // roles: ["Personal", "Expert", "Enterprise"]
        },
      },
      {
        path: "employeeAccount",
        name: "EmployeeAccount",
        component: () => import("@/views/staging/employeeAccount/index.vue"),
        meta: {
          title: "员工账号",
          icon: "accountManage",
          roles: ["Enterprise"],
        },
      },
      {
        path: "accountInformation",
        name: "AccountInformation",
        component: () => import("@/views/staging/accountInformation/index.vue"),
        meta: { title: "账号信息", icon: "user" },
      },
      {
        path: "1",
        name: "1",
        meta: { title: "1", icon: "table", hidden: true },
        children: [
          {
            path: "1-1",
            name: "1-1",
            meta: { title: "1-1" },
          },
          {
            path: "1-2",
            name: "1-2",
            meta: { title: "1-2" },
            children: [
              {
                path: "1-2-1",
                name: "1-2-1",
                meta: { title: "1-2-1" },
              },
              {
                path: "1-2-2",
                name: "1-2-2",
                meta: { title: "1-2-2" },
              },
            ],
          },
          {
            path: "1-3",
            name: "1-3",
            meta: { title: "1-3" },
          },
        ],
      },
    ],
  },
  {
    path: "/payPage",
    name: "PayPage",
    component: () => import("@/views/pay-page/zfb/payPage.vue"),
  },
  {
    path: "/paySuccess",
    name: "PaySuccess",
    component: () => import("@/views/pay-page/PaySuccess.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { left: 0, top: 0, x: 0, y: 0 };
  }
};

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  } else {
    return originalPush.call(this, location).catch(err => err);
  }
};

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});
router.onError(e => {
  console.log("router error");
  console.error(e);
});
export default router;
export const MenusRoutes = routes.find(item => item.name === "Staging").children;
